module.exports = __webpack_public_path__ + "img/linkedin.37cbe010.svg";